import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import camelcaseKeys from 'camelcase-keys';
import {makeStyles} from '@material-ui/core/styles';

import ServiceSelection from '../components/ServiceSelection';
import SearchBox from '../components/SearchBox';
import {ONLINE_SERVICE_FIELD, TELEHEALTH_FIELD} from '../../../constants';
import { getServicesWithMapping } from '../../utils';


const useStyles = makeStyles({
  serviceSelection: {
    marginTop: '14px',
  }
});

const Service = (
  {
    value,
    onChange,
    setAnswers,
    source,
    excludedServices,
  }
) => {
  const classes = useStyles();
  const serviceSelectionServices = source === 'myp' ?
    [
      'Support Work',
      'Gardening',
      'Occupational Therapy',
      'Cleaning',
    ] : [
      'Support Work',
      'Plan Management',
      'Occupational Therapy',
      'Cleaning',
    ];
  const servicesTaxonomy = useSelector(state => state.taxonomy.services);
  const qualifiedServicesTaxonomy = useSelector(state => state.taxonomy.qualifiedServices);

  const [selectedValue, setSelectedValue] = useState(value ? value : []);
  const [serviceMap, setServiceMap] = useState({});
  const [services, setServices] = useState([]);

  useEffect(() => {
    const { services: _services, serviceMap: _serviceMap } = getServicesWithMapping(
      camelcaseKeys(qualifiedServicesTaxonomy, {deep: true}),
      camelcaseKeys(servicesTaxonomy, {deep: true})
    );
    if (excludedServices && Array.isArray(excludedServices)) {
      const excludedServicesSet = new Set(excludedServices);
      const __services = _services.filter(item => {
        return !excludedServicesSet.has(item.name);
      });
      setServices(__services);
    } else {
      setServices(_services);
    }
    setServiceMap(_serviceMap);
  }, [servicesTaxonomy, qualifiedServicesTaxonomy]);

  useEffect(() => {
    onChange(selectedValue);
  }, [selectedValue]);  // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = value => {
    setAnswers(prevState => ({...prevState, [TELEHEALTH_FIELD]: null, [ONLINE_SERVICE_FIELD]: null}));
    setSelectedValue(value ? [value] : []);
  };

  const serviceSelections = serviceSelectionServices.map(key => serviceMap[key]);

  return (
    <>
      <SearchBox
        title="Select a service"
        options={services}
        placeholder="Support Coordination, Gardening ..."
        selectedValue={selectedValue.length ? selectedValue[0] : null}
        onSearchChange={handleChange}
      />
      <ServiceSelection
        title="Commonly requested"
        data={serviceSelections}
        onSelect={handleChange}
        className={classes.serviceSelection}
      />
    </>
  );
};

Service.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  setAnswers: PropTypes.func,
  source: PropTypes.string,
  excludedServices: PropTypes.array,
};

export default Service;